import React, { Component } from "react";
import Email from "../Email/Email";
import AboutContent from "../AboutContent/AboutContent";

require("./GuestContent.scss");
class GuestContent extends Component {
  render() {
    return (
      <div className="guest-content-container">
        <Email />
        <AboutContent />
      </div>
    );
  }
}

export default GuestContent;
